<div class="modal">
  <div class="mh">
    <div>
      <h2>帮助中心</h2>
      <p>
        {{ data.platformInfo.order.platform_name }} ·
        {{ data.problemInfo.name }}
      </p>
    </div>
    <button class="close" mat-dialog-close>×</button>
  </div>
  <mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
  <ng-container *ngIf="!loading">
    <div class="mb" mat-dialog-content>
      <div class="help-sheet">
        <article
          class="help-article"
          *ngFor="let item of articleList; let i = index"
          (click)="gotoArticle(item)"
        >
          <div class="help-article-head">
            <span>帮助文章 {{ i + 1 }}</span>
            <!-- <strong>解决方式一</strong> -->
          </div>
          <p>{{ item.title }}</p>
        </article>
      </div>
    </div>
  </ng-container>
  <div class="mf">
    <button class="btn outline" mat-dialog-close>关闭</button>
    <button class="btn primary" (click)="openAiCustomerService()">
      联系 AI 客服
    </button>
  </div>
</div>
